import { DI } from '@intigral/constant/config/DIContainer';
import { container } from '../../../DataDomain';
import { ISubscriptionRepository } from '../../repositories/interfaces/iSubscriptionRepository';
import { IQrCodeLinkRequest } from '../../../entity/interface/iQrCodes';

export interface IQrCodeLinkUseCase {
    execute(payload: IQrCodeLinkRequest, apiToken: { [key: string]: string }): Promise<boolean>;
}

export class QrCodeLinkUseCase implements IQrCodeLinkUseCase {
    // Lazy getter for repository to avoid circular dependencies
    private get subscriptionRepo(): ISubscriptionRepository {
        return container.resolve<ISubscriptionRepository>(DI.REPOSITORIES.ISubscriptionRepository);
    }

    constructor() {
        // No initialization needed - dependencies resolved lazily via getters
    }

    async execute(payload: IQrCodeLinkRequest, apiToken: { [key: string]: string }): Promise<boolean> {
        const response: any = await this.subscriptionRepo.qrCodeLink(payload, apiToken);
        return response?.data?.status?.toUpperCase() === 'SUCCESS';
    }
}
